module.exports = __webpack_public_path__ + "assets/img/4.eb49b15f.png";